// extracted by mini-css-extract-plugin
export var active = "_it-2";
export var recordingDot = "_it-1";
export var recordingIndicator = "_it-0";